import { breakpoints, space, colors } from '@web-for-marketing/react-ui';

export const subNavigationMobileStyles = {
    subNavigation: {
        overflow: 'hidden',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        boxSizing: 'border-box',
        maxWidth: 1630,
        margin: '0 auto',
        minHeight: '4rem',
        maxHeight: '4rem',
        borderBottom: '1px solid #D9E1E8',
        [`@media (max-width: ${breakpoints.md})`]: {
            overflowX: 'hidden',
        },
        [`@media (min-width: ${breakpoints.sm})`]: {
            minHeight: '4rem',
            maxHeight: '4rem',
        },
    },
    dropDownButton: {
        display: 'flex',
        minHeight: '4rem',
        justifyContent: 'space-between',
        fontWeight: 500,
        fontSize: '1.4rem !important',
        textDecoration: 'none',
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        transform: 'translateX(0px)',
        [`@media (max-width: ${breakpoints.sm})`]: {
            width: '100%',
        },
        '@media (max-width: 1679.9px)': {
            paddingLeft: `${space.containerOuterPadding} !important`,
            paddingRight: `${space.containerOuterPadding} !important`,
        },
        '&:focus': {
            color: colors.text.activeSecondary,
        },
        '&:focus-visible': {
            outline: `1px solid ${colors.core.innovation}`,
            outlineOffset: '-2px',
            borderRadius: '.6rem',
        },
    },
    dropDownMenu: {
        backgroundColor: colors.background.white,
    },
    smallLeftMarginIcon: {
        marginLeft: '0.5rem',
    },
    arrowContainer: {
        margin: '0 1.6rem',
    },
    buttonContainer: {
        backgroundColor: colors.background.light,
    },
    buttonItem: {
        width: '100%',
        padding: '0 !important',
        margin: 0,
        fontWeight: 500,
        fontSize: '1.4rem !important',
        textDecoration: 'none',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        minHeight: '4rem',
        display: 'flex',
        justifyContent: 'flex-start',
        transform: 'translateX(0px)',
        '@media (max-width: 1679.9px)': {
            padding: `1rem ${space.containerOuterPadding} !important`,
        },
        [`@media (max-width: ${breakpoints.sm})`]: {
            width: '100%',
        },
        '&:hover': {
            color: colors.text.activeSecondary,
        },
        '&:focus-visible': {
            outline: `1px solid ${colors.core.innovation}`,
            outlineOffset: '-1px',
            borderRadius: '.6rem',
        },
    },
    linkItemContainer: {
        overflow: 'hidden',
        display: 'flex',
        borderBottom: `1px solid ${colors.border.primary}`,
        minHeight: '4rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            overflowX: 'hidden',
        },
        padding: 0,
    },
    linkItem: {
        color: colors.text.activePrimary,
        width: '100%',
        padding: 0,
        margin: 0,
        fontWeight: 500,
        fontSize: '1.4rem',
        textDecoration: 'none',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        '@media (max-width: 1679.9px)': {
            padding: `1rem ${space.containerOuterPadding}`,
        },
        '&:hover': {
            color: colors.text.activeSecondary,
            textDecoration: 'underline',
        },
        '&:focus': {
            color: colors.text.activeSecondary,
        },
        '&:focus-visible': {
            outline: `1px solid ${colors.core.innovation}`,
            outlineOffset: '-1px',
            borderRadius: '.6rem',
        },
    },
    rotate: {
        transform: 'rotate(180deg)',
    },
} as const;
